import dynamic from 'next/dynamic';

export const BusinessAreas = dynamic(() => import('./BusinessAreas'));
export const Reason = dynamic(() => import('./Reason'));
export const BusinessCard = dynamic(() => import('./BusinessCard'));
export const ReasonCard = dynamic(() => import('./ReasonCard'));
export const ProjectArea = dynamic(() => import('./ProjectArea'));
export const GridProjects = dynamic(() => import('./GridProjects'));
export const NumberCounting = dynamic(() => import('./NumberCounting'));
export const Gallary = dynamic(() => import('./Gallary'));
export const Partner = dynamic(() => import('./Partner'));
export const Slider = dynamic(() => import('./Slider'));
export const FAQ = dynamic(() => import('./FAQ'));
export const Products = dynamic(() => import('./Products'));
export const AboutUs = dynamic(() => import('./AboutUs'));
export const Certification = dynamic(() => import('./Certification'));
